import React from "react";
import { Animated } from "react-native";
import { connect, } from '~/redux/connect';
import { getSearchFilterByModelId, getSearchFilterValue, } from "~/stateGetter";
import { Box, Button, Divider, ClipView, HStack, Icon, Tooltip, WithBaseStyles, } from "~/native-ui";
import { Filter } from "~/ui/Fields/VariadicField/VariadicField";


const StyledButton = WithBaseStyles(Button, {
    baseStyle: {
        right: "0",
        top: "0",
        mt: "2px",
        position: "absolute",
    },
    defaultProps: {
        primary: true,
        _hover: {
            bg: "transparent"
        }
    }
})

class SearchFilter extends React.Component {
    state = {
        filterShown: false
    }

    filterRef = React.createRef(null);

    animationProps = {
        animation: new Animated.Value(0),
        outputRange: [
            `inset(0 0 0 100%)`,
            `inset(0 0 0 0%)`,
        ],
    }

    setFilterRef = (node) => {
        this.filterRef.current = node;
    }

    animate (toValue) {
        return Animated.spring(this.animationProps.animation, {
            toValue: toValue === 1,
            useNativeDriver: false,
            bounciness: 2,
            isInteraction: true,
            speed: 10,
        });
    }

    toggleFilterDisplay = () => {
        // if (this.props.isSearchFilterApplied && this.state.filterShown) {
        //     return;
        // }

        // const filterShown = !this.state.filterShown;
        // this.animate(Number(filterShown)).start();
        // this.setState({ filterShown });

        // if (filterShown) {
        // this.filterRef.current?.focus()
        // }
    }

    onBlurSearchInput = () => {
        this.toggleFilterDisplay()
    }


    getFilterProps() {
        return {
            title: "",
            variant: "rounded",
            isVariadicFilter: false,
            modelId: this.props.modelId,
            name: this.props.modelSearchFilter,
            placeholder: this.props.trans("searchPlaceholder"),
            autoComplete: "off",
            ref: this.setFilterRef,
            onBlur: this.onBlurSearchInput,
            iconRight: <Icon type="search" size="xs" onPress={this.toggleFilterDisplay} mr="2" />
        }
    }


    renderFilter() {
        if (!this.props.modelSearchFilter) {
            return null;
        }

        return (
            <HStack alignItems="center" space="0">
                {/* <ClipView {...this.animationProps}><Filter { ...this.getFilterProps() } /></ClipView> */}
                <Box><Filter { ...this.getFilterProps() } /></Box>
                {/* <Tooltip tooltip={this.props.trans("search")}>
                <StyledButton onPress={this.toggleFilterDisplay} primary icon="search" />
                </Tooltip> */}
                {/* <Divider orientation="vertical" bg="coolGray.300" h="5" ml="4" /> */}
                <Divider orientation="vertical" bg="coolGray.300" h="5" mx="2" ml="4" />
            </HStack>
        )
    }

    render() {
        return <Box>{this.renderFilter()}</Box>
    }
}


const mapStateToProps = (state, { modelId }) => {
    const modelSearchFilter = getSearchFilterByModelId(state, modelId),
          filterValue = getSearchFilterValue(state, modelId),
          isSearchFilterApplied = !!filterValue;

    return {
        modelSearchFilter,
        isSearchFilterApplied,
    }
}


export default connect(mapStateToProps)(SearchFilter)